import { PharmacInputError, PharmacLabel, PharmacSelect } from '@pharmac/ui'
import { PropsWithChildren } from 'react'
import { Controller } from 'react-hook-form'
import { ControlledInputProps } from './dto'
import { isRequiredError } from './form.util'

type ControlledSelectProps = PropsWithChildren &
  ControlledInputProps & {
    valueIsNumber?: boolean
    falsyAsUndefined?: boolean
    requiredError?: string
    valueTransformer?: (value: any) => any
  }

export const ControlledSelect = (props: ControlledSelectProps) => {
  const handleOnChange = (value: any) => {
    if (typeof props.valueTransformer === 'function') {
      console.log(
        'ControlledSelect :: DEBUG :: use valueTransformer',
        props.valueTransformer(value)
      )

      return props.valueTransformer(value)
    }

    if (props.falsyAsUndefined) {
      if (
        !value ||
        (typeof value === 'string' &&
          (value === 'null' || value === 'undefined' || value === 'false'))
      )
        return undefined
    }

    if (props.valueIsNumber) {
      return Number(value)
    }

    return value
  }

  return (
    <>
      {props.label && <PharmacLabel marginSmallBottom>{props.label}</PharmacLabel>}
      <Controller
        rules={props.rules}
        name={props.name}
        control={props.control}
        render={({ field, formState }) => {
          const errorOrUndefined = formState.errors[props.name]

          return (
            <>
              <PharmacSelect
                hasError={!!errorOrUndefined}
                onChange={(value) => field.onChange(handleOnChange(value))}
                value={!field.value ? '' : field.value}
              >
                {props.children}
              </PharmacSelect>
              {isRequiredError(errorOrUndefined) && props.requiredError && (
                <PharmacInputError>{props.requiredError}</PharmacInputError>
              )}
            </>
          )
        }}
      />
    </>
  )
}
